import script from "./PolicyService.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyService.vue?vue&type=script&setup=true&lang=js"

import "./PolicyService.vue?vue&type=style&index=0&id=76cc9c0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76cc9c0e"]])

export default __exports__